import QTIParser from "./qti/qti-parser";
export default QTIParser;
